<template>
  <div class="courseDetailPage">
    <a-row :gutter="_isMobile() ? [0, 20] : [20, 20]">
        <a-col :xs="24" :sm="24" :md="8">
            <img :src="courseDetails.courseCover_url" style="width: 100%;border-radius: 8px;" alt="">    
        </a-col>
        <a-col :xs="24" :sm="24" :md="16">
            <h2 class="courseTitle">{{ courseDetails.courseName }}</h2>    
            <div class="couresInfoStyle">
                <i class="iconfont">&#xe615;</i>学习人数：{{ courseDetails.viewNum || 0 }} <a-divider type="vertical" /> <i style="color: #ea9518;" class="iconfont" v-for="i in courseDetails.courseLevel" :key="i">&#xe604;</i> <span class="ant-rate-text">{{ courseDetails.courseLevel_dictText }}</span>
            </div>
            <div class="couresInfoStyle">
               <i class="iconfont">&#xe62f;</i> 课时总数：{{ courseDetails.courseCount || 0 }} 
               <a-divider type="vertical" />
               完成课时：{{ courseDetails.finishedCount || 0 }} 
            </div>
            <div class="couresInfoStyle">
               <i class="iconfont">&#xe607;</i> 开课时间： {{ courseDetails.beginTime || '-' }} <a-divider type="vertical" /> 结课时间：{{ courseDetails.endTime || '-' }}
            </div>
            <div class="couresInfoStyle">
              <p @click="copyUrl" ><i class="iconfont">&#xebab;</i> 分享</p>  
              <!-- <a-divider type="vertical" />  -->
              <!-- <p><i class="iconfont">&#xe614;</i> 收藏</p> -->
            </div>
            <div style="font-size: 18px;color: red;margin: 10px 30px;"> {{ courseDetails.coursePrice ? `￥${(courseDetails.coursePrice*1)/10/10}`:'免费' }}</div>
            <a-button type="primary" class="sumbitButton" v-if="courseDetails.eventId" @click="goPage"> 立即报名 </a-button>
        </a-col>
    </a-row>
    <a-tabs default-active-key="1" @change="callback" style="width: 100%;">
      <a-tab-pane key="1" tab="课程介绍">
        <div class="detailTabBox" v-if="courseDetails.courseDesc" v-html="courseDetails.courseDesc"></div>
        <a-empty v-else description="暂无课程介绍" />
      </a-tab-pane>
      <a-tab-pane key="2" tab="课程目录" force-render>
        <ul class="catalogueBox" v-if="list.length > 0">
            <li class="cataloguelist" v-for="item,index in list" :key="index">
                <p class="catalogue1">{{item.title}}</p>
                <ul class="catalogueLevelBox">
                    <li v-for="i,n in item.children" :key="n" class="catalogueLevelList" @click="openVideoFn(i)">
                        <p>{{ i.title }}</p>
                        <div class="catalogueLevelListRight">
                            <p class="pTimer">{{ getStudyProgress(i.studyProgress) }}</p>
                            <p class="pButton"><i class="iconfont">&#xe61d;</i>观看</p>
                        </div>
                    </li>
                </ul>
            </li>
        </ul>
        <a-empty v-else description="暂无学习课程" />
      </a-tab-pane>
    </a-tabs>
    <unitView-modal ref="unitViewModal" />
    <CourseMediaViewModalVue ref="mediaViewModal"/>
  </div>
</template>
<script>
import { mixinDevice } from "@/utils/mixin.js";
import UnitViewModal from '@/components/course/UnitViewModal'
import CourseMediaViewModalVue from '@/components/course/CourseMediaViewModal'
import { getAction } from "@/api/manage";
export default {
    mixins: [mixinDevice],
  name: "",
  components: {UnitViewModal, CourseMediaViewModalVue},
  data() {
    return {
        courseDetails:{},
        list:[],
        userInfo: this.$store.state.user.info || {}
    };
  },
  created() {
    this.courseId = this.$route.query.id
    this.getJjData()
    this.getMlData()
  },
  mounted() {},
  methods: {
    callback(){},
    getJjData(){    
        getAction(`/teaching/teachingCourse/get?id=${this.courseId}&userId=${this.userInfo.id}`).then(res=>{
            if(res.code == 200){
                this.courseDetails = res.result
            }
        })
    },
    getMlData(){
        getAction(`/teaching/teachingCourseUnit/showCourseUnitTree?courseId=${this.courseId}&userId=${this.userInfo.id}`).then(data=>{
            this.list = data
        })
    },
    openVideoFn(e){
        console.log(e);
        this.$refs.mediaViewModal.view(this.courseId, e.unitId, e.key)
    },
    goPage(){
        this.$router.push({path:'/event/detail?id=' + this.courseDetails.eventId})
    },
    copyUrl(){
        var input = document.createElement('input');
        input.setAttribute('value',window.location.href);
        document .body.appendChild(input);
        input.select();
        document.execCommand('copy');
        document.body.removeChild(input);
        this.$message.success('复制成功')
    },
    getStudyProgress(progress){
        if(progress >= 0.8){
            return '完成'
        }else{
            return (progress * 100).toFixed(1) + '%'
        }
    }
  },
};
</script>
<style lang='scss' scoped>
  p {
    margin: 0;
  }
  ul,
  li {
    list-style: none;
    margin: 0;
    padding: 0;
  }
.courseTitle{
    font-size: 24px;
    font-weight: bold;
}
.couresInfoStyle{
    font-size: 12px;
    color: #999;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 4px 0;
    p{
        cursor: pointer;
        display: flex;
        align-items: center;
    }
    .iconfont{
        padding-right: 6px;
    }
}
.sumbitButton{
    padding: 0 50px;
    margin: 0 10px;
    background: #174EDA !important;
}
.detailTabBox{
    width: 100%;
    .courseTitle{
      font-size: 18px;
      font-weight: 600;
      color: #333;
      text-align: left;
    }
    .courseName{
        font-size: 16px;
        color: #333;
        padding: 0 20px;
        margin: 10px 0;
    }
    .courseContent{
        font-size: 14px;
        color: #999;
        line-height: 25px;
        padding: 0 20px;
        margin: 10px 0;
    }
}
.catalogueBox{
    width: 100%;
    .cataloguelist{
        width: 100%;
        .catalogue1{
            width: 100%;
            font-size: 24px;
            color: #333;
            background: rgb(249,249,249);
            padding: 10px;
        }
        .catalogueLevelList:hover{
            background: rgb(253, 246, 246);
        }
        .catalogueLevelList{
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 10px 20px;
            box-sizing: border-box;
            cursor: pointer;
            .catalogueLevelListRight{
                display: flex;
                align-items: center;
                justify-content: flex-end;
                line-height: 25px;
                .pButton{
                    width: 60px;
                    text-align: right;
                    .iconfont{
                        padding-right: 5px;
                    }
                }
            }
        }
    }
}
</style>
